"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
let Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript = class Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (!event.args.hit) {
            return;
        }
        container.applyEffect(sequence, event.subject, event.subject, new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamagePercentIncrease, 2), Duration_1.Duration.Permanent);
    }
};
Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_HitsLikeAMackTrk_OnAttack")
], Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript);
exports.Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript = Ability_HitsLikeAMackTrk_OnAttackEventHandlerScript;
